module.exports = __webpack_public_path__ + "static/coach-hire-services-club-pub-trips-c399a93e643036ae1c667fa8d443fa92.jpg";